import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Card, Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { CardBody, CardHeader } from "../../new-withdrawal/styles";
import { MdClose, MdModeEdit } from "react-icons/md";

export const CardAccount = (props: any): JSX.Element => {
  const { t: translation } = useTranslation();
  const { account, handleSelectAccount, accountSelected, handleRemoveAccount, handleEditAccount } = props;

  const [active, setActive] = useState(false);
  const [selected, setSelected] = useState(false);

  const handleClick = (e: any) => {
    if (e.target.tagName.toString() !== 'svg') {
      if (e.target.tagName.toString() !== 'path') {
        handleSelectAccount(account)
      }
    }
  }

  useEffect(() => {
    if (accountSelected === account.account) {
      setSelected(true)
    } else {
      setSelected(false)
    }
  }, [accountSelected])

  return (
    <OverlayTrigger
      placement="top"
      overlay={!selected ? <Tooltip>{translation('manager.withdrawal.selectAccount')}</Tooltip> : <></>}
    >
      <div>
        <Card
          onClick={(e: any) => handleClick(e)}
          onMouseEnter={() => setActive(true)}
          onMouseLeave={() => setActive(false)}
          id={account.id.toString()}
          className={`cursor-pointer ${selected ? 'card-account' : ''}`}
          style={{ borderRadius: '8px', border: '0.5px solid #efefef', filter: 'drop-shadow(0px 2px 8px rgba(51, 51, 51, 0.15))' }}
        >
          <CardHeader>
              <h5>{account.name}</h5>
              {
                active && (
                  <div className="d-flex" style={{ marginTop: '-15px', fontSize: '18px'}}>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Editar</Tooltip>}
                    >
                      <div className="mr-2">
                        <MdModeEdit onClick={() => handleEditAccount(account)}/>
                      </div>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Remover</Tooltip>}
                    >
                      <div>
                        <MdClose onClick={() => handleRemoveAccount(account.id)}/>
                      </div>
                    </OverlayTrigger>
                  </div>
                )
              }
          </CardHeader>
          <CardBody>
              <Row>
                  <Col xs={12} md={6}>
                      <h6>{translation('manager.withdrawal.agency')}: {account.agency}</h6>
                  </Col>
                  <Col xs={12} md={6} className="text-end">
                      <h6>{translation('manager.withdrawal.account')}: {account.account}</h6>
                  </Col>
              </Row>
          </CardBody>
        </Card>
      </div>
    </OverlayTrigger>    
  )
}